import { createContext } from 'react';

interface CommentsContextProps {
    inactiveOwners: string[] | undefined;
    userHasWritePermission: boolean;
    confirmDiscardChanges: ((dataTestId?: string) => Promise<boolean>) | undefined;
}

export const CommentsContext = createContext<CommentsContextProps>({
    inactiveOwners: undefined,
    userHasWritePermission: false,
    confirmDiscardChanges: undefined,
});
